/* tslint:disable */
/* eslint-disable */
export enum WorkProjectCheckCustomerStatusEnum {
  Erledigt = 'ERLEDIGT',
  InArbeit = 'IN_ARBEIT',
  Offen = 'OFFEN'
}
